import {Switch, SwitchField} from "../ui-components/switch.tsx";
import {Label} from "../ui-components/fieldset.tsx";
import {FC} from "react";
import clsx from "clsx";

export const CustomSwitcher: FC<{
    onChangeAction: (checked: boolean) => void,
    label: string,
    value:boolean,
    login?: boolean
}> = ({onChangeAction, label, value, login}) => {

    return (
        <SwitchField className={clsx(`grid grid-cols-[max-content] `, {
            "!gap-1": login,
            "!gap-3": !login
        })}>
            <Switch color={"dark/zinc"}
                    checked={value}
                    onChange={onChangeAction}
                    className="!w-[38px] !h-[22px] sm:!w-[35px] !p-[2px] !col-start-1  bg-[var(--background-switcher)] data-checked:border-transparent border border-[var(--btn-border-custom)] [&>span]:!w-[16px] [&>span]:!h-[16px]"></Switch>
            <Label
                className={clsx(`grid-column-start-start text-left !col-start-2 text-size-sm text-[var(--text-color-dark)] font-medium`, {
                    "!font-semiBold": login,
                    "!font-medium": !login,
                })}>
                {label}
            </Label>
        </SwitchField>
    )
}